const GET_TEST_QUESTIONS = 'QUIZ/GET_TEST_QUESTIONS';
const GET_EMOJI = 'QUIZ/GET_EMOJI';

export default {
  GET_TEST_QUESTIONS,
  GET_EMOJI,
};
